import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackEvent } from 'helpers/Analytics';
import {
  isUnread,
  markAsRead,
  recordAction,
} from 'redux/modules/announcements';
import { isInternalUrl, trackingData } from './announcementContent';

const isPlainLeftClick = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

/**
 * Click handler for an announcement link: tracks it, marks it read (and, for
 * the call to action, records the click), then navigates inside the app so
 * the request isn't cancelled by a full page load. Modifier clicks, external
 * links and pages outside the app (`navigate: false`) are left to the browser.
 */
export default function useOpenAnnouncement(source, onNavigate) {
  const dispatch = useDispatch();
  const history = useHistory();

  return useCallback(
    (
        announcement,
        href,
        { event: eventName, cta = false, navigate = true } = {}
      ) =>
      (event) => {
        trackEvent(eventName, trackingData(announcement, source));

        if (cta) {
          dispatch(recordAction(announcement.id, 'cta-clicked'));
        } else if (isUnread(announcement)) {
          dispatch(markAsRead(announcement.id));
        }

        if (
          navigate &&
          event &&
          isPlainLeftClick(event) &&
          isInternalUrl(href)
        ) {
          event.preventDefault();
          history.push(href);

          if (onNavigate) {
            onNavigate();
          }
        }
      },
    [dispatch, history, source, onNavigate]
  );
}
